"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var OrderClauses = (function (_super) {
    __extends(OrderClauses, _super);
    function OrderClauses(orderClauses, maxLength) {
        if (maxLength === void 0) { maxLength = OrderClauses.DefaultMaxLength; }
        var _this = _super.call(this) || this;
        _this.maxLength = maxLength;
        if (!orderClauses) {
            return _this;
        }
        orderClauses.some(function (clause) {
            if (_this.length >= maxLength) {
                return true; // break the loop if length is at the maxLength
            }
            if (!clause || _this.some(function (existingClause) { return existingClause.field === clause.field; })) {
                return false; // Skip this clause
            }
            _this.push({
                field: clause.field,
                ascending: clause.ascending
            });
            return false; // Keep iterating
        });
        return _this;
    }
    OrderClauses.prototype.prependClause = function (newClause) {
        return new OrderClauses([newClause].concat(this), this.maxLength);
    };
    OrderClauses.prototype.prependAscField = function (field) {
        return this.prependClause({ field: field, ascending: true });
    };
    OrderClauses.prototype.prependDescField = function (field) {
        return this.prependClause({ field: field, ascending: false });
    };
    OrderClauses.prototype.withoutField = function (field) {
        var filteredClauses = this.filter(function (clause) { return clause.field !== field; });
        return new OrderClauses(filteredClauses, this.maxLength);
    };
    OrderClauses.prototype.withMaxLength = function (maxLength) {
        return new OrderClauses(this, maxLength);
    };
    OrderClauses.prototype.startsWithField = function (field) {
        return (this.length > 0) && (this[0].field === field);
    };
    OrderClauses.prototype.findOrderClauseForField = function (field) {
        return this.filter(function (clause) { return clause.field === field; })[0] || null;
    };
    OrderClauses.prototype.filterFields = function (possibleFields) {
        // Create a map to reduce operational time in the following filter
        var possibleFieldsMap = possibleFields.reduce(function (fieldMap, field) {
            fieldMap[field] = true;
            return fieldMap;
        }, {});
        var filteredClauses = this.filter(function (clause) { return possibleFieldsMap[clause.field]; });
        return new OrderClauses(filteredClauses);
    };
    OrderClauses.serializeClause = function (clause) {
        var ascendingString = clause.ascending ? OrderClauses.Direction.asc : OrderClauses.Direction.desc;
        return clause.field + ":" + ascendingString;
    };
    OrderClauses.serialize = function (orderClauses) {
        return orderClauses.map(OrderClauses.serializeClause).join(',');
    };
    OrderClauses.prototype.toString = function () {
        return OrderClauses.serialize(this);
    };
    OrderClauses.deserializeClause = function (input) {
        var parts = input.split(':');
        if (parts.length !== 2) {
            return;
        }
        return {
            field: parts[0],
            ascending: parts[1] === OrderClauses.Direction.asc
        };
    };
    OrderClauses.isIOrderClause = function (clause) {
        return !!clause;
    };
    OrderClauses.deserialize = function (input) {
        if (!input) {
            return; // TODO: or throw?
        }
        return new OrderClauses(input.split(',')
            .map(OrderClauses.deserializeClause)
            .filter(OrderClauses.isIOrderClause)
            .map(function (x) { return x; }));
    };
    OrderClauses.Direction = {
        asc: 'asc',
        desc: 'desc'
    };
    OrderClauses.DefaultMaxLength = 3;
    return OrderClauses;
}(Array));
exports.OrderClauses = OrderClauses;
//# sourceMappingURL=Order.js.map